import { Component, Input, OnInit } from '@angular/core';
import { ColorThreshold } from './progress-bar-count.types';

@Component({
  selector: 'common-progress-bar-count',
  templateUrl: './progress-bar-count.component.html',
  styleUrls: ['./progress-bar-count.component.scss']
})
export class ProgressBarCountComponent implements OnInit {
  @Input() currentValue: number = 0;
  @Input() totalValue: number = 100;
  @Input() backgroundColor: string = '#F0F2F5';
  @Input() showOnlyPercentage: boolean = false;

  @Input() colorThresholds: ColorThreshold[] = [];

  constructor() { }

  ngOnInit(): void {
  }

  get progressPercentage(): number {
    if (this.totalValue === 0) return 0;
    return (this.currentValue / this.totalValue) * 100;
  }

  get progressWidth(): string {
    return `${this.progressPercentage}%`;
  }

  get progressColor(): string {
    const percentage = this.progressPercentage;
    // Find the first threshold that is greater than or equal to the current percentage
    const threshold = this.colorThresholds.find(t => percentage <= t.threshold);
    // Return the color of the found threshold, or the last color if none found
    return threshold?.color || this.colorThresholds[this.colorThresholds.length - 1].color;
  }

  get formattedValues(): string {
    return this.showOnlyPercentage
      ? `${this.currentValue.toLocaleString()}/${this.totalValue.toLocaleString()} (${Math.round(this.progressPercentage)}%)`
      : `${Math.round(this.progressPercentage)}%`
  }
}
